import React, { useState, useEffect } from 'react';
import './Home.css';
import img1 from './asserts/image.jpg';
import img3 from './asserts/image2.png';
import img5 from './asserts/image4.jpg';
import img6 from './asserts/image5.jpg';
import img7 from './asserts/image6.jpg';
import img8 from './asserts/image7.jpg';
import img9 from './asserts/image9.jpg';
import img10 from './asserts/image10.jpg';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import Footer from './Footer';
import { Link } from "react-router-dom";


const Home = () => {
  const images = [img1, img3, img5, img6, img7, img8, img9, img10];
  const [slideIndex, setSlideIndex] = useState(0);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    fetch("http://localhost:5000/api/chapters")
      .then((response) => response.json())
      .then((data) => setMarkers(data))
      .catch((error) => console.error("Error fetching chapters:", error));
  }, []);

  const defaultIcon = new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  const goToNextSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToPrevSlide = () => {
    setSlideIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div>
      <div className="slideshow-container">
      <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '10px', fontFamily: 'Inter', marginTop: "10px" }}>
          Welcome to TISSAA
        </h2>
        <p style={{ textAlign: 'justify', fontSize: '1.2rem', marginBottom: '10px', fontFamily: 'Tahoma', marginLeft: "15px" , marginRight: "15px"}}>
          The Tata Institute of Social Sciences Alums Association (TISSAA) was founded in 2013 during TISS's Platinum Jubilee celebrations to foster lasting connections within the TISS community. As the central body for Alums across all TISS campuses, courses, and batches, TISSAA aims to strengthen Alums engagement, support professional development, contribute to the institution and its students, and create a meaningful impact in society.
        </p>
        <div className="slide-wrapper">
          <img src={images[slideIndex]} alt={`Slide ${slideIndex + 1}`} className="slide-image" />
          <span className="arrow prev" onClick={goToPrevSlide}>❮</span>
          <span className="arrow next" onClick={goToNextSlide}>❯</span>
        </div>
      </div>

      <div className="content-container">
        {/* Text Section */}
        <div className="text-section">
          <h2 className="section-heading" style={{marginTop:"40px"}}> TISSAA Chapters</h2>
          <p className="section-paragraph" style={{textAlign:"justify",marginTop:"40px"}}>
            TISSAA Chapters: Connecting Alumni Worldwide TISSAA Chapters serve as regional hubs, fostering professional, academic, and social collaborations within the alumni network. We currently have active chapters in 21 cities across India, including Mumbai, Delhi, Odisha, Rajasthan, Karnataka, Maharashtra & Goa, Gujarat, and more, as well as in 13 global regions, such as Canada, the US, UK, Australia, Europe, and the Middle East. We’re expanding to places where groups are yet to be formed, including regions in India like Jammu and Kashmir, Punjab, Tamil Nadu, Assam, and globally across Africa, South America, and Asia Pacific.
          </p>
          <p className="section-paragraph" style={{textAlign:"justify",marginTop:"40px"}}>
            <strong>Let’s connect and grow the TISS community together!!!</strong>
            <span className="join-link">
              <Link to="/membership">Join Us</Link>
            </span>
          </p>
        </div>

        {/* Map Section */}
        <div className="map-section" style={{ border: "5px solid #02353c", borderRadius: "10px", edgespadding: "10px",boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)", backgroundColor: "#f9f9f9" }}>
          <MapContainer
            center={[20.5937, 58.9629]}
            zoom={3}
            style={{ height: "450px", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {markers.map((marker, index) =>
              marker.latitude && marker.longitude ? (
                <Marker
                  position={[marker.latitude, marker.longitude]}
                  key={index}
                  icon={defaultIcon}
                >
                  <Popup>
                    <strong>{marker.city}</strong>
                    <br />
                    Coordinator: <strong>{marker.coordinatorName}</strong>
                  </Popup>
                </Marker>
              ) : null
            )}
          </MapContainer>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;







// import React, { useState, useEffect } from 'react';
// import './Home.css'; // Ensure to include the CSS
// import img1 from './asserts/image.png'
// import img2 from './asserts/image1.png';
// import img3 from './asserts/image2.png';

// import img5 from './asserts/image4.jpg';
// // import Calendar from 'react-calendar';
// import 'react-calendar/dist/Calendar.css';

// const Home = () => {
//   const images = [img1, img2, img3, img5];
//   const [slideIndex, setSlideIndex] = useState(0);
//   // const [events, setEvents] = useState([]);
//   // const [selectedDate, setSelectedDate] = useState(new Date());
//   // const [eventText, setEventText] = useState('');
//   // const [editingIndex, setEditingIndex] = useState(null);
//   // const today = new Date();

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [images.length]);

//   const goToNextSlide = () => {
//     setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
//   };

//   const goToPrevSlide = () => {
//     setSlideIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
//   };

//   // const addEvent = () => {
//   //   if (eventText.trim()) {
//   //     setEvents((prevEvents) => [
//   //       ...prevEvents,
//   //       { date: selectedDate.toDateString(), text: eventText },
//   //     ]);
//   //     setEventText('');
//   //   }
//   // };

//   // const updateEvent = (index) => {
//   //   if (eventText.trim()) {
//   //     const updatedEvents = [...events];
//   //     updatedEvents[index].text = eventText;
//   //     setEvents(updatedEvents);
//   //     setEventText('');
//   //     setEditingIndex(null);
//   //   }
//   // };

//   // const deleteEvent = (index) => {
//   //   const updatedEvents = events.filter((_, i) => i !== index);
//   //   setEvents(updatedEvents);
//   // };

//   // const handleEdit = (index, event) => {
//   //   setEditingIndex(index);
//   //   setEventText(event.text);
//   //   setSelectedDate(new Date(event.date));
//   // };

//   return (
//     <div>
      
//       <div className="slideshow-container">
//       <h2 style={{ textAlign: 'center', fontSize: '1.5rem', marginBottom: '-20px' , fontFamily: 'Inter', marginTop:"2px"}}>Welcome to TISSAA</h2>
//   <p style={{ fontSize: '1.2rem', marginBottom: '10px' , fontFamily: 'Tahoma', marginLeft: "15px"}}>
//     The Tata Institute of Social Sciences Alums Association (TISSAA) was founded in 2013 during TISS's Platinum Jubilee celebrations to foster lasting connections within the TISS community. As the central body for Alums across all TISS campuses, courses, and batches, TISSAA aims to strengthen Alums engagement, support professional development, contribute to the institution and its students, and create a meaningful impact in society.
//   </p>
//         <div className="mySlides fade">
//           <img src={images[slideIndex]} alt={`Slide ${slideIndex + 1}`} style={{ width: '100%' }} />
//         </div>
//         <span className="arrow prev" onClick={goToPrevSlide}>❮</span>
//         <span className="arrow next" onClick={goToNextSlide}>❯</span>
//       </div>
//       <footer className="footer">
//     <p>Contact: <a href="mailto:tissa2013@gmail.com">tissa2013@gmail.com</a></p>
//     <p>Mobile: <a href="tel:+919021612549">+91 9021612549</a></p>
//   </footer>
      
      

      
// {/* 
      
//       <div className="floating-calendar">
//         <Calendar onChange={setSelectedDate} value={selectedDate} />
//         <div className="event-input">
//           <h4>Selected Date: {selectedDate.toDateString()}</h4>
//           <input
//             type="text"
//             placeholder="Add or edit event details"
//             value={eventText}
//             onChange={(e) => setEventText(e.target.value)}
//           />
//           {editingIndex !== null ? (
//             <button onClick={() => updateEvent(editingIndex)}>Update Event</button>
//           ) : (
//             <button onClick={addEvent}>Add Event</button>
//           )}
//         </div> */}

//         {/* Events List */}
//         {/* <div className="event-list">
//           <h4>Upcoming Events:</h4>
//           <ul>
//             {events
//               .filter((event) => new Date(event.date) >= today)
//               .map((event, index) => (
//                 <li key={index}>
//                   <strong>{event.date}:</strong> {event.text}{' '}
//                   <button onClick={() => handleEdit(index, event)}>Edit</button>
//                   <button onClick={() => deleteEvent(index)}>Delete</button>
//                 </li>
//               ))}
//           </ul>

//           <h4>Past Events:</h4>
//           <ul>
//             {events
//               .filter((event) => new Date(event.date) < today)
//               .map((event, index) => (
//                 <li key={index}>
//                   <strong>{event.date}:</strong> {event.text}
//                 </li>
//               ))}
//           </ul>
//         </div> */}
//       {/* </div> */}
//     </div>
//   );
// };

// export default Home;
